export default "__VITE_ASSET__CE3wTEFb__"